// src/pages/ContactPage.jsx
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import emailjs from 'emailjs-com';
import {
  FaInstagram,
  FaYoutube ,
  FaPhone,
  FaEnvelope,
  FaWhatsapp,
} from 'react-icons/fa';
import Popup from '../Components/PopUp';

 {/* template_xjs21ch              */}
//  GOjmQYm4Sf7wNGHfc - public key
// service_sk6jqvv - service id

export default function ContactPage() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    event: '',
    location: '',
    date: '',
    message: '',
  });

  const [errors, setErrors] = useState({
    email: '',
    phone: '',
  });
  const [showPopup, setShowPopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMessage, setPopupMessage] = useState("");

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^[6-9]\d{0,9}$/;
  
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'email') {
      if (!emailRegex.test(value)) {
        setErrors((prev) => ({ ...prev, email: 'Enter a valid email address' }));
      } else {
        setErrors((prev) => ({ ...prev, email: '' }));
      }
    }

    if (name === 'phone') {
      if (!/^\d*$/.test(value)) return;

      if (!phoneRegex.test(value)) {
        setErrors((prev) => ({
          ...prev,
          phone: 'Phone must be 10 digits and start with 6-9',
        }));
      } else if (value.length === 10 && phoneRegex.test(value)) {
        setErrors((prev) => ({ ...prev, phone: '' }));
      } else {
        setErrors((prev) => ({
          ...prev,
          phone: 'Phone must be 10 digits and start with 6-9',
        }));
      }
    }

    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
  e.preventDefault();

  const serviceID = '';
  const templateID = '';
  const publicKey = ''; 

  const templateParams = {
    name: form.name,
    email: form.email,
    phone: form.phone,
    message: form.message,
  };

  emailjs.send(serviceID, templateID, templateParams, publicKey)
    .then((response) => {
      console.log('SUCCESS!', response.status, response.text);
      setPopupTitle("Success!");
        setPopupMessage("Your request has been submitted successfully!. We will get back to you shortly.");
        setShowPopup(true);

      setForm({
        name: '',
        email: '',
        phone: '',
        event: '',
        location: '',
        date: '',
        message: '',
      });
    })
    .catch((err) => {
      console.error('FAILED...', err);
      setPopupTitle("Oops!");
        setPopupMessage("Something went wrong. Please try again later.");
        setShowPopup(true);
    });
  };


  // Open Gmail depending on device
  const handleGmailClick = () => {
      const email = 'the.scholarly.edge@gmail.com';
      const subject = 'Inquiry';
      const body = 'Hi Scholarly Edge,\nI would like to inquire about...';

      const gmailURL = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(body)}`;

      if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      // On mobile – use native mail app
       window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      } else {
       // On desktop – open Gmail Web Compose
       window.open(gmailURL, '_blank');
      }
  };

  const handleDateChange = (e) => {
  const selected = e.target.value; 
  const [year, month, day] = selected.split('-');
  const formatted = `${day}-${month}-${year}`; 
  setForm({ ...form, date: formatted });
};



  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-50 via-white to-white px-10 py-12">
      <div className="max-w-4xl mx-auto space-y-10">
        {/* Heading */}
        <div className="space-y-2">
          <h2 className="text-4xl font-extrabold text-center text-transparent bg-clip-text bg-gradient-to-r from-purple-600 via-purple-500 via-40% to-pink-400">
           Contact Us
          </h2>
          <p className="text-center text-gray-600 text-lg">
            Fill out the form below to inquire about availability, pricing, or any questions you may have.
          </p>
        </div>

        {/* Contact Form */}
        <form
          onSubmit={handleSubmit}
          className="space-y-4 bg-white p-8 rounded-2xl shadow-lg border border-purple-100"
        >
          <input
            className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-purple-400"
            type="text"
            name="name"
            placeholder="Your Name"
            value={form.name}
            onChange={handleChange}
            required
          />
          <div>
            <input
              className={`w-full p-3 border rounded focus:outline-none focus:ring-2 ${
                errors.email
                  ? 'border-red-400 focus:ring-red-300'
                  : 'border-gray-300 focus:ring-purple-400'
              }`}
              type="email"
              name="email"
              placeholder="Your Email"
              value={form.email}
              onChange={handleChange}
              required
            />
            {errors.email && (
              <p className="text-red-500 text-sm mt-1">{errors.email}</p>
            )}
          </div>
          <div>
            <input
              className={`w-full p-3 border rounded focus:outline-none focus:ring-2 ${
                errors.phone
                  ? 'border-red-400 focus:ring-red-300'
                  : 'border-gray-300 focus:ring-purple-400'
              }`}
              type="tel"
              name="phone"
              placeholder="Your Phone Number"
              value={form.phone}
              onChange={handleChange}
              maxLength="10"
              required
            />
            {errors.phone && (
              <p className="text-red-500 text-sm mt-1">{errors.phone}</p>
            )}
          </div>

          <textarea
            className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-purple-400"
            name="message"
            placeholder="Additional Details"
            rows={5}
            value={form.message}
            onChange={handleChange}
          />

          <motion.button
            type="submit"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            transition={{ type: 'spring', stiffness: 300 }}
            className="w-full px-6 py-3 text-white font-medium rounded shadow bg-gradient-to-r from-purple-600 via-pink-500 to-red-400 hover:from-purple-700 hover:via-pink-600 hover:to-red-500 transition"
          >
            Submit
          </motion.button>
        </form>

        <Popup
        show={showPopup}
        onClose={() => setShowPopup(false)}
        title={popupTitle}
        message={popupMessage}
      />

        {/* Contact Info */}
        <div className="bg-white p-6 rounded-2xl shadow-md border border-purple-100">
          <h3 className="text-xl font-semibold text-center text-purple-600 mb-4">
            Contact Details
          </h3>
          <div className="space-y-3 text-gray-700 text-sm">
            {/* Phone */}
            <p className="flex items-center gap-2 justify-center">
              <FaPhone className="text-purple-500" />
              <a
                href="tel:7420029121"
                className="hover:underline hover:text-purple-700"
              >
                +91 7420029121

              </a>
                /
               <a
                href="tel:7028723640"
                className="hover:underline hover:text-purple-700"
              >
                +91 7028723640
              </a>
            </p>

            {/* Email with Gmail logic */}
            <p
               className="flex items-center gap-2 justify-center cursor-pointer group text-gray-700 hover:text-purple-700"
               onClick={handleGmailClick}
            >
             <FaEnvelope className="text-purple-500" />
             <span className="group-hover:underline">
               the.scholarly.edge@gmail.com
             </span>
           </p>

          </div>

          {/* Social Media */}
          <div className="pt-4 flex justify-center space-x-6">
      
            <a
              href="https://wa.me/7420029121"
              target="_blank"
              rel="noopener noreferrer"
              className="text-purple-500 hover:text-purple-700 text-xl"
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
